export const PERMISSIONS = {
  // PIT_TAG
  PIT_TAG_IMPORT: 'PIT_TAG.IMPORT',
  PIT_TAG_DELETE: 'PIT_TAG.DELETE',
  PIT_TAG_CREATE: 'PIT_TAG.CREATE',
  PIT_TAG_VIEW: 'PIT_TAG.VIEW',

  // USER
  USER_CREATE: 'USER.CREATE',
  USER_VIEW: 'USER.VIEW',
  USER_UPDATE: 'USER.UPDATE',

  // ROLES
  ROLES_CREATE: 'ROLES.CREATE',
  ROLES_VIEW: 'ROLES.VIEW',
  ROLES_UPDATE: 'ROLES.UPDATE',
  ROLES_DELETE: 'ROLES.DELETE',
  ROLES_ADD_USER: 'ROLES.ADD_USER',

  // COMPANY
  COMPANY_CREATE: 'COMPANY.CREATE',
  COMPANY_VIEW: 'COMPANY.VIEW',
  COMPANY_UPDATE: 'COMPANY.UPDATE',

  // FACILITY
  FACILITY_VIEW: 'FACILITY.VIEW',

  // UNIT
  UNIT_CREATE: 'UNIT.CREATE',
  UNIT_VIEW: 'UNIT.VIEW',
  UNIT_UPDATE: 'UNIT.UPDATE',
  UNIT_DELETE: 'UNIT.DELETE',

  // TAG
  TAG_CREATE: 'TAG.CREATE',
  TAG_VIEW: 'TAG.VIEW',
  TAG_DELETE: 'TAG.DELETE',
  TAG_IMPORT: 'TAG.IMPORT',

  // BREEDPROGRAM
  BREEDPROGRAM_CREATE: 'BREEDPROGRAM.CREATE',
  BREEDPROGRAM_VIEW: 'BREEDPROGRAM.VIEW',
  BREEDPROGRAM_UPDATE: 'BREEDPROGRAM.UPDATE',
  BREEDPROGRAM_IMPORTBROODSTOCK: 'BREEDPROGRAM.IMPORTBROODSTOCK',
  BREEDPROGRAM_ASSIGNTANK: 'BREEDPROGRAM.ASSIGNTANK',
  BREEDPROGRAM_FINALIZEBROODSTOCK: 'BREEDPROGRAM.FINALIZEBROODSTOCK',
  BREEDPROGRAM_DISCARD: 'BREEDPROGRAM.DISCARD',

  // BREEDMATING
  BREEDMATING_CREATE: 'BREEDMATING.CREATE',
  BREEDMATING_VIEW: 'BREEDMATING.VIEW',
  BREEDMATING_UPDATE: 'BREEDMATING.UPDATE',
  BREEDMATING_DELETE: 'BREEDMATING.DELETE',

  // BREEDMORTALITY
  BREEDMORTALITY_CREATE: 'BREEDMORTALITY.CREATE',
  BREEDMORTALITY_VIEW: 'BREEDMORTALITY.VIEW',

  // BREEDFEEDING
  BREEDFEEDING_VIEW: 'BREEDFEEDING.VIEW',

  // BREEDWEIGHT
  BREEDWEIGHT_VIEW: 'BREEDWEIGHT.VIEW',

  // BREEDBATCH
  BREEDBATCH_VIEW: 'BREEDBATCH.VIEW',

  // BREEDHATCHING
  BREEDHATCHING_PREHATCH: 'BREEDHATCHING.PREHATCH',
  BREEDHATCHING_ADDHATCHING: 'BREEDHATCHING.ADDHATCHING',
  BREEDHATCHING_VIEW: 'BREEDHATCHING.VIEW',
  BREEDHATCHING_HARVEST: 'BREEDHATCHING.HARVEST',
  BREEDHATCHING_STOCKTOLARVAE: 'BREEDHATCHING.STOCKTOLARVAE',

  // BREEDLARVAE
  BREEDLARVAE_VIEW: 'BREEDLARVAE.VIEW',
  BREEDLARVAE_TRANSFER: 'BREEDLARVAE.TRANSFER',
  BREEDLARVAE_EDITLARVIA: 'BREEDLARVAE.EDITLARVIA',
  BREEDLARVAE_AFKIRDISCARD: 'BREEDLARVAE.AFKIRDISCARD',
  BREEDLARVAE_FLUSHDISCARD: 'BREEDLARVAE.FLUSHDISCARD',
  BREEDLARVAE_STOCKTOGO: 'BREEDLARVAE.STOCKTOGO',
  BREEDLARVAE_STOCKTOPLPROD: 'BREEDLARVAE.STOCKTOPLPROD',
  BREEDLARVAE_ADDMONITORING: 'BREEDLARVAE.ADDMONITORING',
  BREEDLARVAE_ADDMONITORING_PL4: 'BREEDLARVAE.ADDMONITORING_PL4',
  BREEDLARVAE_ADDTEMPERATURE: 'BREEDLARVAE.ADDTEMPERATURE',

  // BREEDGO
  BREEDGO_VIEW: 'BREEDGO.VIEW',
  BREEDGO_ADDSAMPLING: 'BREEDGO.ADDSAMPLING',
  BREEDGO_VIEWSAMPLING: 'BREEDGO.VIEWSAMPLING',
  BREEDGO_DISCARD: 'BREEDGO.DISCARD',
  BREEDGO_3GRAM: 'BREEDGO.3GRAM',
  BREEDGO_3GRAMSAMPLING: 'BREEDGO.3GRAMSAMPLING',
  BREEDGO_20GRAM: 'BREEDGO.20GRAM',
  BREEDGO_20GRAMSAMPLING: 'BREEDGO.20GRAMSAMPLING',

  // BREEDGENTANK
  BREEDGENTANK_VIEW: 'BREEDGENTANK.VIEW',
  BREEDGENTANK_ADDIDENTIFIER: 'BREEDGENTANK.ADDIDENTIFIER',
  BREEDGENTANK_DISCARD: 'BREEDGENTANK.DISCARD',
  BREEDGENTANK_TRANSFERTOPROD: 'BREEDGENTANK.TRANSFERTOPROD',
  BREEDGENTANK_TRANSFERTOGO: 'BREEDGENTANK.TRANSFERTOGO',

  // CLIENT
  CLIENT_CREATE: 'CLIENT.CREATE',
  CLIENT_VIEW: 'CLIENT.VIEW',
  CLIENT_UPDATE: 'CLIENT.UPDATE',
  CLIENT_DELETE: 'CLIENT.DELETE',

  // DISEASECHALLENGE
  DISEASECHALLENGE_CREATE: 'DISEASECHALLENGE.CREATE',
  DISEASECHALLENGE_VIEW: 'DISEASECHALLENGE.VIEW',
  DISEASECHALLENGE_UPDATE: 'DISEASECHALLENGE.UPDATE',
  DISEASECHALLENGE_DELETE: 'DISEASECHALLENGE.DELETE',

  // CAGETRIAL
  CAGETRIAL_CREATE: 'CAGETRIAL.CREATE',
  CAGETRIAL_VIEW: 'CAGETRIAL.VIEW',
  CAGETRIAL_UPDATE: 'CAGETRIAL.UPDATE',

  // MYTASK
  MYTASK_VIEW: 'MYTASK.VIEW',

  // SCHEDULETEMPLATE
  SCHEDULETEMPLATE_VIEW: 'SCHEDULETEMPLATE.VIEW',
  SCHEDULETEMPLATE_CREATE: 'SCHEDULETEMPLATE.CREATE',
  SCHEDULETEMPLATE_UPDATE: 'SCHEDULETEMPLATE.UPDATE',

  // SCHEDULETASK
  SCHEDULETASK_VIEW: 'SCHEDULETASK.VIEW',
  SCHEDULETASK_CREATE: 'SCHEDULETASK.CREATE',
  SCHEDULETASK_UPDATE: 'SCHEDULETASK.UPDATE',

  // REDELEGATETASK
  REDELEGATETASK_VIEW: 'REDELEGATETASK.VIEW',
  REDELEGATETASK_CREATE: 'REDELEGATETASK.CREATE',
  REDELEGATETASK_UPDATE: 'REDELEGATETASK.UPDATE',

  // BREEDALGAE
  // BREEDALGAE module has no actions in the current API response

  // REPORT_BREEDING
  REPORT_BREEDING_MATURATION_FEEDING_DAILY: 'REPORT_BREEDING.MATURATION.FEEDING_DAILY',
  REPORT_BREEDING_LARVAE_POPULATION_AND_SR_PL10_ACTUAL: 'REPORT.BREEDING.LARVAE.POPULATION_AND_SR_PL10_ACTUAL',
  REPORT_BREEDING_GROWOUT_AVG_WEIGHT: 'REPORT.BREEDING.GROWOUT.AVG_WEIGHT',
  REPORT_BREEDING_MATURATION_PL_TRIAL_BATCH: 'REPORT_BREEDING.MATURATION.PL_TRIAL_BATCH',
  REPORT_BREEDING_HATCHING_AVG_EGG_NAUPLI: 'REPORT.BREEDING.HATCHING.AVG_EGG_NAUPLI',
  REPORT_BREEDING_GROWOUT_AVG_ADG: 'REPORT.BREEDING.GROWOUT.AVG_ADG',
  REPORT_BREEDING_MATURATION_TOTAL_AVG_MATING: 'REPORT_BREEDING.MATURATION.TOTAL_AVG_MATING',
  REPORT_BREEDING_HATCHING_AVG_FERTIL_HATCHING_PERCENTAGE: 'REPORT.BREEDING.HATCHING.AVG_FERTIL_HATCHING_PERCENTAGE',
  REPORT_BREEDING_LARVAE_POPULATION_AND_SR_PL10_ESTIMATE: 'REPORT.BREEDING.LARVAE.POPULATION_AND_SR_PL10_ESTIMATE',
  REPORT_BREEDING_LARVAE_LARVAE_TEMPERATURE: 'REPORT.BREEDING.LARVAE.LARVAE_TEMPERATURE',
  REPORT_BREEDING_LARVAE_LARVAE_DATA: 'REPORT.BREEDING.LARVAE.LARVAE_DATA',
  REPORT_BREEDING_LARVAE_POPULATION_AND_SR_PL4_ESTIMATE: 'REPORT.BREEDING.LARVAE.POPULATION_AND_SR_PL4_ESTIMATE',
  REPORT_BREEDING_MATURATION_MATING_TOTAL_AND_MORTALITY: 'REPORT_BREEDING.MATURATION.MATING_TOTAL_AND_MORTALITY',
  REPORT_BREEDING_MATURATION_MATING_PER_TANK: 'REPORT_BREEDING.MATURATION.MATING_PER_TANK',
  REPORT_BREEDING_LARVAE_AVG_PL10_POPULATION: 'REPORT.BREEDING.LARVAE.AVG_PL10_POPULATION',

  // REPORT_CAGETRIAL & REPORT_DISEASE_CHALLENGE
  REPORT_CAGETRIAL_WEIGHT_SR: 'REPORT.CAGETRIAL.WEIGHT_SR',
  REPORT_CAGETRIAL_ALL_CAGE_DEFORMITIES: 'REPORT.CAGETRIAL.ALL_CAGE_DEFORMITIES',
  REPORT_CAGETRIAL_NBC_DEFORMITIES: 'REPORT.CAGETRIAL.NBC_DEFORMITIES',
  REPORT_CAGETRIAL_CAGE_DEFORMITIES: 'REPORT.CAGETRIAL.CAGE_DEFORMITIES',
  REPORT_CAGETRIAL_TAGGING_SHIPPING: 'REPORT.CAGETRIAL.TAGGING_SHIPPING',
  REPORT_DISEASE_CHALLENGE_ALL_CAGE_DEFORMITIES: 'REPORT.DISEASE_CHALLENGE.ALL_CAGE_DEFORMITIES',
  REPORT_DISEASE_CHALLENGE_CAGE_DEFORMITIES: 'REPORT.DISEASE_CHALLENGE.CAGE_DEFORMITIES',
  REPORT_DISEASE_CHALLENGE_WEIGHT_SR: 'REPORT.DISEASE_CHALLENGE.WEIGHT_SR',
} as const;

export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];
